import { AnySourceStream, Stream, Subscription } from '../stream'

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        asPromiseOnComplete(): Promise<DC>
    }
}

Stream.prototype.asPromiseOnComplete = function <C>(this: AnySourceStream<any, any, C>) {
    return new Promise<C>((resolve, reject) => {
        const subscription: Subscription<C> = {
            complete: (val: C) => {
                this.unsubscribe(subscription)
                resolve(val)
            },
            error: (err: any) => {
                this.unsubscribe(subscription)
                reject(err)
            },
        }
        this.subscribe(subscription)
    })
}
